naja.addEventListener('success', (event) => {
    let payload = event.detail.payload;
    // Vymazat pole "event" před odesláním nové události
    if(!_.isUndefined(payload.datalayerPush) && Array.isArray(payload.datalayerPush)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function() {
        this.reset();
        })

        payload.datalayerPush.forEach(item => {
            // Pokud je item string (JSON), převedeme na objekt
            if (typeof item === 'string') {
                try {
                    item = JSON.parse(item);
                } catch (e) {
                    console.error('Chyba při parsování JSON:', e);
                    return;
                }
            }
            window.dataLayer.push(item);
        });
    }
});
